import UploadFileInput from "./upload-file-input";

export default UploadFileInput;
